import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceForm from '../../../components/forms/InvoiceForm';
import { useInvoiceApi } from '../../../hooks/useInvoiceApi';
import { useNavigate } from 'react-router-dom';
import { InvoiceDTO } from '../../../services/apiClient';

const InvoiceCreate: React.FC = () => {
  const { create, isLoading } = useInvoiceApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoices', href: '/admin/invoices' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/invoices');
    } catch (error) {
      console.error('Error creating Invoice:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoices"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Invoice.Edit'
    >
        <InvoiceForm
          initialValues={{} as InvoiceDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/invoices')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default InvoiceCreate;